// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"demo_title__1cyW9","demo-button":"demo_demo-button__3il65"};